'use client'

import Button from '@/components/ui/Button'
import Link from 'next/link'
import { signInWithPassword } from '@/utils/saas/auth-helpers/server'
import { handleRequest } from '@/utils/saas/auth-helpers/client'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

// Define prop type with allowEmail boolean
interface PasswordSignInProps {
  allowEmail: boolean
  redirectMethod: string
}

export default function PasswordSignIn({
  allowEmail,
  redirectMethod,
}: Readonly<PasswordSignInProps>) {
  const tmpRouter = useRouter()
  const router = redirectMethod === 'client' ? tmpRouter : null
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    console.log('handleSubmit() - e=', e)
    setIsSubmitting(true) // Disable the button while the request is being handled
    await handleRequest(e, signInWithPassword, router)
    setIsSubmitting(false)
  }

  return (
    <div className="my-8">
      <form
        id="password-sign-in"
        noValidate={true}
        className="mb-4"
        onSubmit={(e) => {
          // NOTE: Intentionally not awaited.
          void handleSubmit(e)
        }}
      >
        <div className="grid gap-2">
          <div className="grid gap-1">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              placeholder="name@example.com"
              type="email"
              name="email"
              autoCapitalize="none"
              autoComplete="email"
              autoCorrect="off"
              className="w-full p-3 rounded-md bg-theme-gray-200 dark:bg-theme-gray-800"
            />
            <label htmlFor="password">Password</label>
            <input
              id="password"
              placeholder="Password"
              type="password"
              name="password"
              autoComplete="current-password"
              className="w-full p-3 rounded-md bg-theme-gray-200 dark:bg-theme-gray-800"
            />
          </div>
          <Button
            id="password-sign-in-button"
            variant="slim"
            type="submit"
            className="mt-1"
            loading={isSubmitting}
          >
            Sign in
          </Button>
        </div>
      </form>
      <p>
        {/* @@TODO */}
        <Link
          href="/saas/signin/forgot_password"
          className="font-light text-sm"
        >
          {'Forgot your password?'}
        </Link>
      </p>
      {allowEmail && (
        <p>
          {/* @@TODO */}
          <Link href="/saas/signin/email_signin" className="font-light text-sm">
            {'Sign in via magic link'}
          </Link>
        </p>
      )}
      <p>
        {/* @@TODO */}
        <Link href="/saas/signin/signup" className="font-light text-sm">
          {"Don't have an account? Sign up"}
        </Link>
      </p>
    </div>
  )
}
